/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Timeline_TitleInputs */

const vi_carrier_timeline_title = /** @type {(inputs: Carrier_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hành trình vận chuyển`)
};

/**

* @param {Carrier_Timeline_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_timeline_title = /** @type {((inputs?: Carrier_Timeline_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Timeline_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_timeline_title(inputs)
});